module.exports = __webpack_public_path__ + "static/media/3-7.036cca97.mp3";